module.exports = __webpack_public_path__ + "static/media/img_noble.53867ca6.jpg";